/* src/app/private/components/client-package/client-package.component.scss */
::ng-deep .beautiful-modal {
}
::ng-deep .beautiful-modal .p-dialog {
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  border: none;
  font-family: "Inter", sans-serif;
}
::ng-deep .beautiful-modal .p-dialog-header {
  padding: 1.25rem 1.5rem 1rem;
  background: #ffffff;
  border-bottom: 1px solid #f3f4f6;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-title {
  font-weight: 600;
  font-size: 1.25rem;
  color: #111827;
  margin: 0;
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-header-icons {
  gap: 0.5rem;
  display: flex;
  align-items: center;
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-header-icons .p-dialog-header-close {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: none;
  cursor: pointer;
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-header-icons .p-dialog-header-close:hover {
  background: #ffe4e6;
  color: #ef4444;
  transform: translateY(-1px);
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-header-icons .p-dialog-header-close:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #fee2e2;
  outline: none;
}
::ng-deep .beautiful-modal .p-dialog-header .p-dialog-header-icons .p-dialog-header-close .p-dialog-header-close-icon {
  font-size: 0.875rem;
}
::ng-deep .beautiful-modal .p-dialog-content {
  padding: 1.5rem;
  background: #ffffff;
  color: #374151;
}
::ng-deep .beautiful-modal .p-dialog-content .p-dropdown {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  transition: all 0.2s;
}
::ng-deep .beautiful-modal .p-dialog-content .p-dropdown:not(.p-disabled):hover {
  border-color: #3b82f6;
}
::ng-deep .beautiful-modal .p-dialog-content .p-dropdown.p-focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
::ng-deep .beautiful-modal .p-dialog-content .p-dropdown .p-dropdown-label {
  padding: 0.65rem 0.75rem;
  font-size: 0.95rem;
}
::ng-deep .beautiful-modal .p-dialog-content label {
  color: #374151;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.35rem;
  display: block;
}
::ng-deep .beautiful-modal .p-dialog-footer {
  padding: 1rem 1.5rem 1.5rem;
  background: #ffffff;
  border-top: none;
  text-align: right;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}
::ng-deep .beautiful-modal .p-dialog-footer button {
  margin-left: 0.5rem;
}
::ng-deep .beautiful-modal .p-button {
  border-radius: 8px;
  font-weight: 500;
  padding: 0.6rem 1.25rem;
  transition: all 0.2s;
  font-size: 0.95rem;
  border: 1px solid transparent;
}
::ng-deep .beautiful-modal .p-button.p-button-primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #ffffff;
}
::ng-deep .beautiful-modal .p-button.p-button-primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.3);
}
::ng-deep .beautiful-modal .p-button.p-button-primary:disabled {
  background: #93c5fd;
  border-color: #93c5fd;
  cursor: not-allowed;
}
::ng-deep .beautiful-modal .p-button.p-button-text {
  color: #6b7280;
  background: transparent;
}
::ng-deep .beautiful-modal .p-button.p-button-text:hover {
  background: #f3f4f6;
  color: #111827;
}
::ng-deep .beautiful-modal .p-button.p-button-danger {
  background: #dc2626;
  border-color: #dc2626;
}
::ng-deep .beautiful-modal .p-button.p-button-danger:hover {
  background: #b91c1c;
  box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3);
}
/*# sourceMappingURL=client-package.component.css.map */
